import React from "react";

export default function burger(props) {
  const { onClick, open } = props;

  const handleClick = (e) => onClick(e);

  return (
    <div className="giving-burger-bun" onClick={handleClick}>
      <button
        data-testid="t-MenuBar-GivingD--Burger-toggle-navigation-dr"
        className={open == true ? "giving-burger giving-burger-open" : "giving-burger"}
        aria-label="Toggle navigation drawer"></button>
    </div>
  );
}
